import fetch from 'isomorphic-unfetch'
import { NextPage } from 'next'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import FAQ from 'modules/FAQ'
import * as T from 'modules/FAQ/types'

import { useCloseHeaderModal } from 'services/hooks'

const PageContainer = styled.div`
  width: 100%;
  padding-bottom: 5px;
  background-color: ${props => props.theme.colors.grey16};
`

const showAllAnchor: T.IAnchor = {
  anchor: 'showAll',
  title: 'Show All',
  entries: [],
}

const FAQPage: NextPage<T.IFaqProps> = ({ anchors }) => {
  // cleanup if user navigated from header modal
  useCloseHeaderModal()

  const router = useRouter()
  const queryAnchor = router.asPath.split('#')[1] || ''

  useEffect(() => {
    if (queryAnchor) {
      // scroll to the element with the id of the queryAnchor
      const element = document.getElementById(queryAnchor)

      if (element) element.scrollIntoView()
    }
  }, [queryAnchor])

  const [selectedAnchor, setSelectedAnchor] = useState('showAll')
  const selectAnchor = (anchor: string) => setSelectedAnchor(anchor)

  const currentAnchor
    = selectedAnchor === 'showAll'
      ? showAllAnchor
      : anchors.find((a: T.IAnchor) => a.anchor === selectedAnchor)

  return (
    <PageContainer>
      <Head>
        <title>FAQs, Frequently Asked Questions, and More | HomeLister</title>
        <meta
          name="description"
          content="Read top FAQs and other frequently asked questions that other sellers and buyers have asked at HomeLister. Sell your home today with HomeLister."
        />
        <meta
          name="keywords"
          content="FAQs, Frequently Asked Questions, HomeLister"
        />
        <meta
          name="og:description"
          property="og:description"
          content="Read top FAQs and other frequently asked questions that other sellers and buyers have asked at HomeLister. Sell your home today with HomeLister."
        />
      </Head>
      <FAQ
        anchors={anchors}
        currentAnchor={currentAnchor}
        selectAnchor={selectAnchor}
        selectedAnchor={selectedAnchor}
        queryAnchor={queryAnchor}
      />
    </PageContainer>
  )
}

FAQPage.getInitialProps = async () => {
  try {
    const res = await fetch(`${process.env.API_URL}/faq`)
    const data = await res.json()

    return {
      anchors: data,
    }
  } catch (error) {
    return {
      anchors: [],
    }
  }
}

export default FAQPage
